import { post, get ,postQuery} from "@/utils/service";

// 消息列表
export function tableList(params = {}) {
    const url = "/api/Msg/ListMsgNoticeRecord"
    return post(url, params);
}
// 全部置为已读
export function allRead(params = {}) {
    const url = "/api/Msg/ClickMsgNotice"
    return post(url, params);
}
// 消息汇总通知
export function groupMsgNoticeRecord(params = {}) {
    const url = "/api/Msg/GroupMsgNoticeRecord"
    return post(url, params);
}




// WEBPACK FOOTER //
// ./src/api/menuList/index.js